<template>
  <el-dialog
    v-dialogDrag
    :visible.sync="dialogVisible"
    width="88%"
    height="62vh"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :before-close="dialogClose"
  >
    <div slot="title" class="title-container">
      <img class="logo" src="@/common/assets/images/login-logo.svg" />
      <div class="text">检查项目结果确认</div>
    </div>
    <div class="modal-window-text">
      <w-table
        ref="inspectTable"
        :data="tablesData"
        highlight-current-row
        :span-method="objectSpanMethod"
        style="width: 100%"
        height="46vh"
        border
      >
        <w-table-column
          prop="XMMC"
          label="项目"
          align="center"
          width="90"
        ></w-table-column>
        <w-table-column prop="BZMC" label="质量标准" align="center">
          <template slot-scope="scope" align="left">
            <div :id="scope.row.BZDM" class="flex">
              <w-popover
                v-if="tablesData.length > 200 && scope.row.BZMC.length > 18"
                trigger="hover"
                :content="scope.row.BZMC"
                >{{ scope.row.BZMC }}</w-popover
              >
              <div v-else>{{ scope.row.BZMC }}</div>
            </div>
          </template>
        </w-table-column>
        <w-table-column
          v-if="showField.isShowKFBZColumn"
          prop="KFMC"
          label="扣分标准"
          align="center"
        >
        </w-table-column>
        <w-table-column label="检查者" width="150">
          <template slot-scope="scope">
            <!-- <el-radio v-model="scope.row.isSelect" :label="scope.row.JCZ" @input="clickChange($event,scope)">{{ scope.row.JCZ }}</el-radio> -->
            <div class="radio_box">
              <div
                class="radio_dot"
                :class="scope.row.isSelect == true ? 'bg' : ''"
                @click="clickChange(scope)"
              >
                <div
                  class="dot"
                  :class="scope.row.isSelect == true ? 'dot_border' : ''"
                ></div>
              </div>
              <div class="content">{{ scope.row.JCZMC }}</div>
            </div>
          </template>
        </w-table-column>
        <!-- 核查表特有项 -->
        <w-table-column
          v-if="
            showField.TSHCB === '1' ||
            (showField.isHGL === '1' && showField.JFFS !== 1132)
          "
          label="结果&样本&占比情况"
          prop="JGDM"
          width="220"
        >
          <template slot-scope="scope">
            <div
              v-for="list in scope.row.HCBJGList"
              :key="list.JGDM"
              class="flex"
            >
              <span class="w50">{{ list.JGMC }}</span>
              <w-input
                v-model.number="list.YBSL"
                class="w30"
                :maxlength="3"
                :disabled="
                  scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
                "
                @change="getHGL(list, scope.$rowIndex, scope.row)"
              ></w-input>
              <span class="w20">{{
                showField.bsySfcyjs
                  ? Number((list.YBZB * 100).toFixed(2)) + '%'
                  : list.ISNRFM === '0' && list.ISNRJS === '0'
                  ? '0%'
                  : Number((list.YBZB * 100).toFixed(2)) + '%'
              }}</span>
            </div>
          </template>
        </w-table-column>
        <w-table-column
          label="合格率"
          width="80"
          v-if="
            showField.TSHCB === '1' ||
            (showField.isHGL === '1' && showField.JFFS !== 1132)
          "
        >
          <template slot-scope="scope">
            <span>{{ Number((scope.row.HGL * 100).toFixed(2)) + '%' }}</span>
          </template>
        </w-table-column>
        <!-- 百分制表单特有项 -->
        <w-table-column
          v-if="showField.JCFS !== 1024"
          prop="KFFZ"
          label="分值"
          :width="70"
        ></w-table-column>
        <w-table-column
          v-if="
            showField.TSHCB === '0' &&
            !showField.isQualifiedRateCheck &&
            showField.isHGL !== '1'
          "
          prop="KFJG"
          :label="showField.JCFS !== 1024 ? '扣加分' : '结果'"
          :width="showField.JCFS !== 1024 ? 100 : 120"
        >
          <template slot-scope="scope">
            <w-input
              v-if="showField.JCFS === 1022 && scope.row.KFFS === 1016"
              v-model="scope.row.KFJG"
              :disabled="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              @change="
                (item) => {
                  handleMark(item, scope.$index, scope.row, 'input')
                }
              "
            ></w-input>
            <!--1068 自由扣分扣分最大值为BZFZ,其他扣分类型最大扣分值为BZFZ -->
            <w-input-number
              v-else-if="
                showField.JCFS === 1022 &&
                (scope.row.KFFS === 1018 ||
                  scope.row.KFFS === 0 ||
                  scope.row.KFFS === -1)
              "
              v-model="scope.row.KFJG"
              :disabled="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              :increment="showField.xtmj1195"
              :min="0"
              :max="
                scope.row.JFFS === 1068
                  ? scope.row.XMFZ
                  : scope.row.JFFS === 1183
                  ? scope.row.BZFZ
                  : scope.row.JFFS === 1184
                  ? scope.row.BDZF
                  : Number(scope.row.KFFZ)
              "
              size="small"
              style="min-width: 100%"
              @change="
                (item) => {
                  handleMark(item, scope.$index, scope.row)
                }
              "
            ></w-input-number>
            <!--1017 百分制表单用下拉控件展示-->
            <w-select
              v-else-if="showField.JCFS === 1022 && row.KFFS === 1017"
              v-model="scope.row.KFJG"
              :disabled="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              popper-append-body
              style="min-width: 100%"
              @change="
                (val) => {
                  handleScoreChange(val, scope.row)
                }
              "
            >
              <w-option
                v-for="item in scope.row.KFXXList"
                :key="item"
                :label="item"
                :value="item"
              ></w-option>
            </w-select>
            <w-radio-group
              v-else
              v-model="scope.row.KFJG"
              :disabled="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
            >
              <w-radio
                v-for="ck in showField.checkResultList"
                :key="ck.JGDM"
                style="display: block; text-align: left; margin: 5px 0px"
                size="small"
                :label="ck.JGDM.toString()"
              >
                {{ ck.JGMC }}
              </w-radio>
            </w-radio-group>
          </template>
        </w-table-column>
        <!-- 公用表单项 -->
        <w-table-column label="未涉及" width="70">
          <template slot-scope="scope">
            <w-checkbox
              v-model="scope.row.SFWSJ"
              :disabled="!scope.row.editAble || !scope.row.isSelect"
              @change="(val) => handleSFWSJ(val, scope.row)"
            ></w-checkbox>
          </template>
        </w-table-column>
        <w-table-column prop="KFYYSM" label="扣分原因说明" width="250">
          <template slot-scope="scope">
            <w-input
              v-model="scope.row.KFYYSM"
              type="textarea"
              :disabled="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              placeholder="请选择扣分原因说明"
              style="float: left; width: 75%"
              :maxlength="1000"
              @change="handleChangeContent"
            >
            </w-input>
            <w-popover
              ref="popoverReasons"
              trigger="click"
              :visible-arrow="false"
              :open-delay="0"
              :close-delay="0"
              popper-class="padd0 w_popover_container"
              :append-to-body="false"
              style="float: left"
              @hidden="hide"
            >
              <popover-reason
                v-if="showReason"
                :reason-list="reasonListData"
                :self-reason="scope.row.selfReason ? scope.row.selfReason : ''"
                @hide="hide"
                @selfReason="
                  (val) => {
                    addSelfReasonFn(val, scope.row)
                  }
                "
                @deleteSelfReason="
                  (val) => {
                    deleteSelfReasonFn(val, scope.row)
                  }
                "
              ></popover-reason>
              <template slot="reference">
                <w-button
                  class="arrow-container"
                  :disabled="
                    scope.row.SFWSJ ||
                    !scope.row.editAble ||
                    !scope.row.isSelect
                  "
                  @click="handleClickArrow(row)"
                >
                  <i class="w-icon-triangle-bottom"></i>
                </w-button>
              </template>
            </w-popover>
          </template>
        </w-table-column>
        <w-table-column
          v-if="formData.JCLX !== 1020"
          prop="BCHSDM"
          label="被查护士"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <div
              v-if="
                !scope.row.SFWSJ && scope.row.editAble && scope.row.isSelect
              "
              style="display: flex"
            >
              <w-select
                :ref="'bchs-' + scope.$index"
                v-model="scope.row.BCHSDM"
                multiple
                collapse-tags
                :tags-threshold="1"
                placeholder=""
                popper-append-body
                @visible-change="selectIndex = scope.$index"
                @change="
                  (val) => {
                    handleBchsChange(val, scope.row)
                  }
                "
              >
                <w-option
                  v-for="item in scope.row.BCHSArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></w-option>
              </w-select>
              <popover-nurse
                label-key="BCHSMC"
                value-key="BCHSDM"
                :index="scope.$index"
                :row="{
                  OrgId: showField.ORGID,
                  ...scope.row,
                  type: 'checkForHs'
                }"
                @changeValue="changeBCHS"
              >
              </popover-nurse>
            </div>
            <w-input
              v-else-if="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              :disabled="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              :value="scope.row.BCHSMC === '' ? '' : scope.row.BCHSMC.join(',')"
              placeholder="请选择"
              @change="handleChangeContent"
            >
              <template slot="suffix">
                <i class="w-icon-template" style="font-size: 16px" />
              </template>
            </w-input>
          </template>
        </w-table-column>
        <w-table-column
          prop="ZRRDM"
          :label="showField.xtmj1113"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <div
              v-if="
                !scope.row.SFWSJ && scope.row.editAble && scope.row.isSelect
              "
              style="display: flex"
            >
              <w-select
                :ref="'zrr-' + scope.$index"
                v-model="scope.row.ZRRDM"
                multiple
                collapse-tags
                :tags-threshold="1"
                popper-append-body
                @visible-change="selectIndex = scope.$index"
                @change="
                  (val) => {
                    handleZrrChange(val, scope.row)
                  }
                "
              >
                <w-option
                  v-for="item in scope.row.zrrArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></w-option>
              </w-select>
              <popover-nurse
                label-key="ZRRMC"
                value-key="ZRRDM"
                :index="scope.$index"
                :row="{
                  OrgId: showField.ORGID,
                  ...scope.row,
                  type: 'checkForHs'
                }"
                @changeValue="changePerson"
              >
              </popover-nurse>
            </div>
            <w-input
              v-else-if="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              :disabled="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              :value="scope.row.ZRRMC.join(',')"
              placeholder="请选择"
            >
              <template slot="suffix">
                <i class="w-icon-template" style="font-size: 16px" />
              </template>
            </w-input>
          </template>
        </w-table-column>
        <w-table-column
          v-if="
            formData.JCLX === 1020 ||
            (formData.JCLX === 1019 && showField.Mjdm === '1')
          "
          label="被查患者"
          width="150"
        >
          <template slot-scope="scope">
            <div
              v-if="
                !scope.row.SFWSJ && scope.row.editAble && scope.row.isSelect
              "
              style="display: flex"
            >
              <w-select
                :ref="'bchz-' + scope.$index"
                v-model="scope.row.BCBRDM"
                placeholder=""
                multiple
                collapse-tags
                :tags-threshold="1"
                popper-append-body
                @visible-change="selectIndex = scope.$index"
                @change="
                  (val) => {
                    handleBchzChange(val, scope.row)
                  }
                "
              >
                <w-option
                  v-for="item in scope.row.BCHZArr"
                  :key="item.ID"
                  :label="item.Name"
                  :value="item.ID"
                ></w-option>
              </w-select>
              <img
                class="pic-people left"
                src="@/common/assets/images/addpeople.png"
                alt="people"
                @click="addPatientPop(scope.row, scope.$index)"
              />
            </div>
            <w-input
              v-else-if="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              :disabled="
                scope.row.SFWSJ || !scope.row.editAble || !scope.row.isSelect
              "
              :value="scope.row.BCBRMC.join(',')"
              placeholder="请选择"
            >
              <template slot="suffix">
                <img
                  class="pic-people left"
                  src="@/common/assets/images/addpeople.png"
                  alt="people"
                />
              </template>
            </w-input>
          </template>
        </w-table-column>
        <!-- <w-table-column label="附件" align="center" width="80">
              <template  slot-scope="scope">
                <i
                  class="w-icon-picture add-img"
                  style="color: #0c93b1"
                  @click="handleOpenUpload(scope.row)"
                />
                <span class="imgNum">{{ scope.row.TPSL ? scope.row.TPSL : '' }}</span>
              </template>
          </w-table-column> -->
      </w-table>
    </div>
    <div class="modal-window-footer">
      <div class="window-footer-btns">
        <w-button type="primary" @click="closePop()"> 关 闭 </w-button>
        <w-button type="primary" @click="saveData"> 确 定 </w-button>
      </div>
    </div>
    <patients-dialog
      v-if="patientPopVisible"
      :dialog-visible="patientPopVisible"
      :dialog-close="patientClose"
      :basic-infor="patientRow"
      :zzjgdm="formData.SJKS"
    ></patients-dialog>
    <!-- 上传附件 -->
    <upload-list
      v-if="upImgVisible"
      :dialog-visible="upImgVisible"
      :upload-info="uploadImgInfo"
      :dialog-close="uploadImgDialogClose"
      @updateNum="updateImgNum"
    />
  </el-dialog>
</template>

<script>
// checkResultList 确定为核查表，选择结果
// checkTypeInfo 表示检查表的类型 1022是百分制 1024 是核查表
import PopoverNurse from '@/common/components/PopoverNurse'
import PopoverReason from '../Popover'
import PatientsDialog from './PatientsDialog'
import { mapMutations, mapState } from 'vuex'
import UploadList from './UploadList.vue'
import { formatInput } from '@/common/utils/index.js'
export default {
  name: 'MultipleInspect',
  components: {
    PopoverNurse,
    PopoverReason,
    UploadList,
    PatientsDialog
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogClose: {
      type: Function,
      default: () => {}
    },
    row: {
      type: Array,
      default: []
    },
    showField: {
      type: Object,
      default: () => {
        return {}
      }
    },
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rowData: {},
      tablesData: [],
      mergeObj: {},
      mergeArr: ['XMMC', 'BZMC', 'KFMC'],
      reasonListData: [], //扣分原因
      patientPopVisible: false,
      showReason: false,
      upImgVisible: false,
      uploadImgInfo: {},
      patientRow: {},
      dialogZrrArray: [],
      tableIndex: 0
    }
  },
  computed: {},
  watch: {},
  created() {
    this.tablesData = this.row
    // 初始化处理表单数据
    this.resultTable()
  },
  mounted() {
    this.getSpanArr(this.tablesData)
  },
  methods: {
    ...mapMutations('check', ['SET_BEFORE_CLOSE']),
    getSpanArr(data) {
      //处理表单那数据，准备合并表格
      this.mergeArr.forEach((key, index) => {
        let count = 0 // 用来记录需要合并行的起始位置
        this.mergeObj[key] = [] // 记录每一列的合并信息
        data.forEach((item, index) => {
          // index == 0表示数据为第一行，直接 push 一个 1
          if (index === 0) {
            this.mergeObj[key].push(1)
          } else {
            // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
            if (item[key] === data[index - 1][key]) {
              this.mergeObj[key][count] += 1
              this.mergeObj[key].push(0)
            } else {
              // 如果当前行和上一行其值不相等
              count = index // 记录当前位置
              this.mergeObj[key].push(1) // 重新push 一个 1
            }
          }
        })
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //合并表格
      // 判断列的属性
      if (this.mergeArr.indexOf(column.property) !== -1) {
        // 判断其值是不是为0
        if (this.mergeObj[column.property][rowIndex]) {
          return [this.mergeObj[column.property][rowIndex], 1]
        } else {
          // 如果为0则为需要合并的行
          return [0, 0]
        }
      }
    },
    closePop() {
      //关闭页面
      this.dialogClose()
    },
    resultFj(data) {
      return data === '' ? '--' : data
    },
    saveData() {
      //已解决冲突
      //判断一下需要提交几条数据
      let targetData = []
      let submitArray = []
      this.tablesData.forEach((item, index) => {
        if (item.isSelect == true) {
          item.index = index
          submitArray.push(item)
        }
        if (item.editAble == true) {
          targetData.push(item)
        }
      })
      // 数据长度不一样，还有冲突项要解决
      if (targetData.length != submitArray.length) {
        this.$msg('您还有冲突项未解决，请解决冲突项后再提交数据', 'info')
        return
      }
      // 验证用用户是否未填写
      //  let isFillIn1 = false
      //  let isFillIn2 = false
      //  let isFillIn3 = false
      //  let isFillIn4 = false
      //  submitArray.forEach(item =>{
      //     if(item.KFYYSM == ''){
      //       isFillIn1 = true  //扣分原因未填写
      //     }
      //     if(item.BCHSDM.length === 0){
      //       isFillIn2 = true  // 被查护士没填
      //     }
      //     if(item.ZRRDM.length == 0){
      //       isFillIn3 = true
      //     }
      //     if(item.BCBRDM.length == 0){
      //       isFillIn4 = true
      //     }
      //  })
      //  if(isFillIn2 && this.formData.JCLX != 1020){
      //   this.$msg('被查护士必须填写必须填写', 'info')
      //   return
      //  }
      //  if(isFillIn1){
      //     this.$msg('扣分原因必须填写', 'info')
      //     return
      //  }
      //  if(isFillIn3){
      //    this.$msg('责任人必须填写', 'info')
      //    return
      //  }
      //  if(isFillIn4 && (this.formData.JCLX == 1020 || this.formData.JCLX == 1019)){
      //    this.$msg('被查患者必须填写', 'info')
      //    return
      //  }
      //提交数据
      this.$emit('conflictData', submitArray)
    },
    clickChange(data) {
      let targetID = data.row.KFDM
      this.tablesData.forEach((item) => {
        //设置指定检查者
        item.XZJCZ = item.JCZ

        // 同一项
        if (item.KFDM == targetID) {
          // 如果检查者能匹配上,哪一项被选上了
          if (item.onlyId === data.row.onlyId) {
            item.isSelect = true
          } else {
            item.isSelect = false
          }
        }
      })
      this.$set(this.tablesData, data.$index, data.row)
    },
    handleClickArrow(row) {
      //扣分原因选择
      this.SET_BEFORE_CLOSE(true)
      this.showReason = true
      this.queryRensonFn(row)
    },
    //查询原因
    queryRensonFn(row) {
      this.$requestApi('GetKFYYList', {
        BDDM: row.BDDM,
        BZDM: row.BZDM,
        YYMC: ''
      }).then((res) => {
        this.reasonListData = res.data.map((v) => {
          return {
            YYMC: v.YYMC,
            id: v.YYDM,
            KFFZ: v.KFFZ,
            SFLSYY: v.SFLSYY
          }
        })
      })
    },
    addSelfReasonFn(val, row) {
      // 删除扣分原因
      if (!val) {
        this.$msg('扣分原因说明不能为空！')
        return
      }
      if (Array.isArray(val)) {
        let KFJG = 0
        val.forEach((item) => {
          row.KFYYSM
            ? (row.KFYYSM = row.KFYYSM + '\n' + item.YYMC)
            : (row.KFYYSM = item.YYMC)
          KFJG += item.KFFZ ? item.KFFZ : 0
        })
        let maxNum =
          row.JFFS === 1068
            ? row.XMFZ
            : row.JFFS === 1183
            ? row.BZFZ
            : row.JFFS === 1184
            ? row.BDZF
            : row.BZFZ
        if (KFJG && KFJG > 0) {
          row.KFJG = KFJG > Number(maxNum) ? Number(maxNum) : KFJG
          // this.calcScore('')
        }
      } else {
        this.saveReasonFn(row, val)
        row.selfReason = ''
      }
    },
    saveReasonFn(row, val) {
      // 提交扣分原因
      this.$requestApi('SaveKFYY', {
        BDDM: row.BDDM,
        BZDM: row.BZDM,
        YYMC: val,
        SFLSYY: 1
      }).then((res) => {
        this.queryRensonFn(row)
      })
    },
    deleteSelfReasonFn(val, row) {
      if (val == null || val.length == 0) {
        this.$msg('请选择要删除的扣分原因')
        return
      }
      let deleteFlag = true
      for (var i = 0; i < val.length; i++) {
        if (val[i].SFLSYY != 1) {
          deleteFlag = false
          break
        }
      }
      // 删除提示
      if (!deleteFlag) {
        this.$msg('不能删除检查表单设置时所增加的扣分原因')
        return
      }
      // 删除数据提交
      this.$requestApi('DeleteKFYY', {
        YYDM: val.map((item) => item.id).join(',')
      }).then((res) => {
        this.queryRensonFn(row)
      })
    },
    // 一级部门新增默认传入的orgid
    handleChangeContent() {
      this.SET_BEFORE_CLOSE(true)
    },
    handleBchsChange(val, row) {
      this.SET_BEFORE_CLOSE(true)
      // 被查护士筛选，添加 val 的类型是['20230000000726',"20230000000721"],BCHSArr 已选择的被护士数组
      row.BCHSMC = []
      for (let i = 0; i < val.length; i++) {
        // 当选择的护士存在BCHSArr中添加到 BCHSMC中国
        row.BCHSMC.push(row.BCHSArr.find((item) => item.id == val[i]).name)
      }
      // row.zrrArr = []
      if (this.isToZRRY === '1') {
        // 开启 1077参数时, 责任人赋值
        row.ZRRDM = row.BCHSDM
        row.ZRRMC = row.BCHSMC
      } else if (this.isToZRRY === '2') {
        // 1077参数开启后，取组织结构中的责任人(ZYFZR为3)
        if (this.showField.HSZinfo.length > 0 && row.BCHSDM.length > 0) {
          // 有护士长 有被查护士数据
          for (let i = 0; i < this.HSZinfo.length; i++) {
            if (!row.ZRRDM.includes(this.showField.HSZinfo[i].CYGH)) {
              row.ZRRDM.push(this.showField.HSZinfo[i].CYGH) // 如果责任人中不包含护士长，就把护士长添加到责任人数组当中
              row.ZRRMC.push(
                this.showField.HSZinfo[i].CYXM.includes('(')
                  ? this.showField.HSZinfo[i].CYXM
                  : this.showField.HSZinfo[i].CYXM +
                      '(' +
                      this.showField.HSZinfo[i].CYGH +
                      ')'
              )
            }
          }
        }
      }
      this.getZrrArr(row)
      for (let i = 0; i < val.length; i++) {
        if (!this.showField.bjczOptions.some((j) => j.id == val[i])) {
          this.showField.bjczOptions.push({
            id: val[i],
            name: row.BCHSMC[i]
          })
        }
        if (!this.formData.BJCZDM.includes(row.BCHSDM[i])) {
          this.formData.BJCZDM.push(row.BCHSDM[i])
        }
        if (!this.showField.bjczOptionsHs.some((j) => j.id == val[i])) {
          this.showField.bjczOptionsHs.push({
            id: val[i],
            name: row.BCHSMC[i]
          })
        }
      }
    },
    handleZrrChange(val, row) {
      this.SET_BEFORE_CLOSE(true)
      row.ZRRMC = []
      for (let i = 0; i < val.length; i++) {
        row.ZRRMC.push(row.zrrArr.find((item) => item.id == val[i]).name)
      }
    },
    handleBchzChange(val, row) {
      this.SET_BEFORE_CLOSE(true)
      row.BCBRMC = []
      for (let i = 0; i < val.length; i++) {
        row.BCBRMC.push(row.BCHZArr.find((item) => item.ID == val[i]).Name)
        if (!this.showField.bjczOptions.some((j) => j.id == val[i])) {
          this.showField.bjczOptions.push({
            id: val[i],
            name: row.BCBRMC[i],
            isPatient: true
          })
          if (!this.formData.BJCZDM.includes(row.BCHSDM[i])) {
            this.formData.BJCZDM.push(row.BCHSDM[i])
          }
        }
      }
      if (this.showField.isToZRRY === '3') {
        row.zrrArr = row.zrrArr.filter((i) => i.flag != '1')
        row.ZRRDM = row.ZRRDM.filter((i) => row.zrrArr.find((j) => j.id == i))
        row.ZRRMC = row.ZRRMC.filter((i) => row.zrrArr.find((j) => j.name == i))
      }
      if (
        row.BCBRDM &&
        row.BCBRDM.length > 0 &&
        this.showField.isToZRRY === '3' &&
        row.BCHZArr &&
        row.BCHZArr.length > 0
      ) {
        // 保存后打开不能够知道患者是门诊还是院区的
        let blhs = row.BCBRDM.filter((m) => {
          return row.BCHZArr.some((k) => {
            return k.ID == m && (k.type == undefined || k.type == '1')
          })
        }).join(',')
        let arr = []
        row.BCBRDM.forEach((i) => {
          if (this.dialogZrrArray.find((j) => j.ID == i && j.ZRHSList)) {
            this.dialogZrrArray
              .find((j) => j.ID == i && j.ZRHSList)
              .ZRHSList.forEach((k) => {
                if (k && k.ID && k.NAME) {
                  arr.push(k)
                }
              })
          }
        })
        if (blhs) {
          if (arr && arr.length > 0) {
            row.zrrArr = [
              ...arr.map((m) => {
                return {
                  id: m.ID,
                  name: m.NAME,
                  flag: '1'
                }
              }),
              ...row.zrrArr
            ]
          }

          let newArr = []
          if (row.zrrArr.length > 0) {
            newArr.push(row.zrrArr[0])
          }
          for (let i = 1; i < row.zrrArr.length; i++) {
            if (!newArr.find((item) => item.id == row.zrrArr[i].id)) {
              newArr.push(row.zrrArr[i])
            }
          }
          row.zrrArr = newArr
          row.ZRRDM = arr.map((m) => m.ID)
          row.ZRRMC = arr.map((m) => m.NAME)
        }
      }
    },
    addPatientPop(row, index) {
      // 点击打开检查患者弹框
      this.SET_BEFORE_CLOSE(true)
      this.patientRow = row
      this.tableIndex = index
      this.patientPopVisible = true
    },
    changePerson(row, index) {
      this.SET_BEFORE_CLOSE(true)
      this.$set(this.tablesData, index, row)
      this.getZrrArr(row)
    },
    getZrrArr(row) {
      for (let i = 0; i < row.ZRRDM.length; i++) {
        if (!row.zrrArr.find((item) => item.id === row.ZRRDM[i])) {
          row.zrrArr.push({
            id: row.ZRRDM[i],
            name: row.ZRRMC[i]
          })
        }
      }
    },
    handleScoreChange(val, row, type) {
      this.SET_BEFORE_CLOSE(true)
      // this.calcScore()
      if (type && type === 'radio') {
        const hcbj = row.HCBJGList.find((v) => v.JGDM.toString() === val)

        //radio 要根据 ISNRFM 和 ISNRJS判断
        if (
          this.showField.xtmj1179 != '0' &&
          row.firstHandle === 0 &&
          hcbj &&
          hcbj.ISNRFM === '1' &&
          hcbj.ISNRJS === '0'
        ) {
          this.dealKFYYSM(row)
        }

        const optionList = row.HCBJGList || []
        const result = optionList.some((m) => m.JGDM == val && m.ISNRJS === '0')
        // const ifBack =
        //   optionList.find((m) => m.JGDM == val).ISNRFM !== '0' &&
        //   optionList.find((m) => m.JGDM == val).ISNRJS === '0'
        if (result) {
          // this.settingRowBJCZ(1, row)
        } else {
          // 1179参数开启时，自动填充扣分原因说明
          if (
            this.showField.xtmj1179 != '0' &&
            row.firstHandle === 0 &&
            val !== '0' &&
            Number(val) !== 0
          ) {
            this.dealKFYYSM(row)
          }
          // this.settingRowBJCZ(0, row)
        }
        // if (ifBack) {
        //   this.ifBack(row, 1)
        // }
        return
      } else {
        // this.ifBack(row, val)
      }
      // this.settingRowBJCZ(val, row)
    },
    // 计算得分
    calcScore(row) {
      //是否未涉及
      if (row && row.SFWSJ) {
        row.HGL = 1 //未涉及的就 100%
        if (this.form.JCFS != 1024) {
          row.KFJG = null
        }

        if (row.HCBJGList && row.HCBJGList.length > 0) {
          row.HCBJGList.forEach((item) => {
            item.YBSL = 0
            item.YBZB = 0
          })
        }
      }
      let ZKJCInfoList = JSON.parse(JSON.stringify(this.tablesData))
      ZKJCInfoList.forEach((item) => {
        item.BCHSDM = item.BCHSDM.join(',')
        item.BCHSMC = item.BCHSMC.join(',')
        item.BCBRDM = item.BCBRDM.join(',')
        item.BCBRMC = item.BCBRMC.join(',')
        item.ZRRDM = item.ZRRDM.join(',')
        item.ZRRMC = item.ZRRMC.join(',')
        item.BJCZDM = item.BJCZDM.join(',')
        item.BJCZMC = item.BJCZMC.join(',')
      })
      let ZKJCModel = {
        BDDM: this.form.JCBD,
        BDMC: this.form.JCBDMC,
        CFXH: this.form.CFXH, // 新建时拆分序号暂时 无法获取到
        ZZJGDM: this.form.SJKS,
        JCZID: this.form.JCZ,
        JCZMC: this.form.ZZMC, //改变后需重新赋值
        QTJCZID: Array.isArray(this.form.QTJCZID)
          ? this.form.QTJCZID.join(',')
          : this.form.QTJCZID,
        QTJCZMC: this.form.QTJCZMC,
        IsSave: '', // 保存 / 提交
        QZXS: this.form.HCB_QZ,
        ZKJCInfoList, //接传递table数据
        BJCZDM: this.form.BJCZDM.join(',')
      }
      CalcZKJCData(ZKJCModel).then((res) => {
        this.scoreInfo = res.data
      })
    },
    changeBCHS(row, index) {
      this.SET_BEFORE_CLOSE(true)
      if (this.isToZRRY === '1') {
        row.ZRRDM = row.BCHSDM
        row.ZRRMC = row.BCHSMC
      } else if (this.isToZRRY === '2') {
        // 1077参数开启后，取组织结构中的责任人(ZYFZR为3)
        if (this.showField.HSZinfo.length > 0 && row.BCHSDM.length > 0) {
          for (let i = 0; i < this.showField.HSZinfo.length; i++) {
            if (!row.ZRRDM.includes(this.showField.HSZinfo[i].CYGH)) {
              row.ZRRDM.push(this.showField.HSZinfo[i].CYGH)
              row.ZRRMC.push(
                this.showField.HSZinfo[i].CYXM.includes('(')
                  ? this.showField.HSZinfo[i].CYXM
                  : this.showField.HSZinfo[i].CYXM +
                      '(' +
                      this.showField.HSZinfo[i].CYGH +
                      ')'
              )
            }
          }
        }
      }
      this.getZrrArr(row)
      this.$set(this.tablesData, index, row)
      for (let i = 0; i < row.BCHSDM.length; i++) {
        if (!row.BCHSArr.find((item) => item.id === row.BCHSDM[i])) {
          row.BCHSArr.push({
            id: row.BCHSDM[i],
            name: row.BCHSMC[i]
          })
        }
        if (!row.zrrArr.find((item) => item.id === row.BCHSDM[i])) {
          row.zrrArr.push({
            id: row.BCHSDM[i],
            name: row.BCHSMC[i]
          })
        }
        if (!this.showField.bjczOptions.find((j) => j.id == row.BCHSDM[i])) {
          this.showField.bjczOptions.push({
            id: row.BCHSDM[i],
            name: row.BCHSMC[i]
          })
        }
        if (!this.showField.bjczOptionsHs.some((j) => j.id == row.BCHSDM[i])) {
          this.showField.bjczOptionsHs.push({
            id: row.BCHSDM[i],
            name: row.BCHSMC[i]
          })
        }
        if (!this.formData.BJCZDM.includes(row.BCHSDM[i])) {
          this.formData.BJCZMC.push(row.BCHSMC[i])
          this.formData.BJCZDM.push(row.BCHSDM[i])
        }
      }
    },
    patientClose(val) {
      //关闭获取被查患者弹框
      this.patientPopVisible = false
      if (val) {
        //添加到下拉框
        this.tablesData.forEach((item) => {
          for (let i = 0; i < val.length; i++) {
            if (!item.BCHZArr.find((item) => item.ID === val[i].ID)) {
              item.BCHZArr.push({
                ID: val[i].ID,
                Name: val[i].Name
              })
            }
          }
        })

        // this.tablesData[this.tableIndex].BCBRDM

        const values = []
        const names = []
        const patient = []
        val.map((v) => {
          if (!this.formData.BJCZDM.includes(v.ID)) {
            values.push(v.ID)
            names.push(v.Name)
          }
          const isExsit =
            this.showField.bjczOptions != null &&
            this.showField.bjczOptions.some((item) => item.id == v.ID)
          if (!isExsit) {
            patient.push({
              id: v.ID,
              name: v.Name,
              isPatient: true
            })
          }
          this.dialogZrrArray.push({
            ID: v.ID,
            ZRHSList: v.ZRHSList
          })
        })
        const bjczArr = _.clone(this.showField.bjczOptions) || []
        this.showField.bjczOptions = bjczArr.concat(patient)
        this.concatPeople(val)
      }
    },
    concatPeople(val) {
      for (let i = 0; i < val.length; i++) {
        if (this.showField.jczOptions.find((j) => j.UserId == val[i].ID)) {
          return
        }
        this.showField.jczOptions = this.showField.jczOptions.concat({
          UserId: val[i].ID,
          UserName: val[i].Name
        })
      }
    },
    //隐藏表单
    hide() {
      document.body.click()
    },
    // 选择未涉及
    handleSFWSJ(val, row) {
      if (val) {
        row.KFYYSM = ''
        row.BCBRMC = []
        row.BCBRDM = []
        row.ZRRMC = []
        row.ZRRDM = []
        row.BCHSMC = []
        row.BCHSDM = []
      }
    },
    // 打开上传
    handleOpenUpload(row) {
      if (row.SFWSJ || !row.editAble) {
        return
      }
      this.SET_BEFORE_CLOSE(true)

      let rowIndex = 1
      this.tablesData.forEach((i) => {
        if (i.KFDM === row.KFDM) {
          if (i.XSXH == 0 && rowIndex > 1) {
            i.XSXH = rowIndex
          }
          rowIndex++
        }
      })

      this.uploadImgInfo = row
      this.uploadImgInfo.MXJCID = this.uploadImgInfo.MXJCID
        ? this.uploadImgInfo.MXJCID
        : 'Temp_' + new Date().getTime()
      this.upImgVisible = true
    },
    updateImgNum(num) {
      if (this.uploadImgInfo.MXJCID.toString().indexOf('Temp_') <= -1) {
        this.tablesData.find(
          (i) =>
            i.ID == this.uploadImgInfo.ID && i.XSXH == this.uploadImgInfo.XSXH
        ).TPSL = num
      } else {
        this.tablesData.find(
          (i) =>
            i.Index == this.uploadImgInfo.Index &&
            i.XSXH == this.uploadImgInfo.XSXH
        ).TPSL = num
      }
    },
    //上传
    uploadImgDialogClose() {
      this.upImgVisible = false
    },
    resultTable() {
      // 初始赋值
      this.tablesData.forEach((item, index) => {
        let totalYBS = eval(
          item.HCBJGList.map((item) => (item.YBSL ? item.YBSL : 0)).join('+')
        )
        if (item.HGL === 0 && totalYBS === 0) {
          item.HGL = 1
        }
        //第一个取 判断未达标等扣分项id
        if (index === 0 && item.HCBJGList && item.HCBJGList.length > 0) {
          this.KF_JGDM_INDEX = item.HCBJGList.findIndex(
            (v) => v.ISNRFM === '1' && v.ISNRJS === '0'
          )
        }
      })

      this.tablesData.forEach((item, index) => {
        item.BCHSArr = []
        item.BCHZArr = []
        item.zrrArr = []
        item.isSelect = false
        if (this.rowData.KFXDM) {
          // item.editAble = this.rowData.KFXDM.split(',').indexOf(item.KFDM + '') > -1
          item.redXM = item.XMDM == redXM
          item.redZLBZ = item.BZDM == redZLBZ
        } else {
          // item.editAble = true
          this.rowData.KFXDM = false
        }
        // 设置被查护士
        item.BCHSDM = item.BCHSDM ? item.BCHSDM.split(',') : []
        item.BCHSMC = item.BCHSMC ? item.BCHSMC.split(',') : []
        // 循环添加到下拉框
        for (let i = 0; i < item.BCHSDM.length; i++) {
          item.BCHSArr.push({ id: item.BCHSDM[i], name: item.BCHSMC[i] })
        }
        // 设置责任人
        item.ZRRDM = item.ZRRDM ? item.ZRRDM.split(',') : []
        item.ZRRMC = item.ZRRMC ? item.ZRRMC.split(',') : []
        // 循环添加到责任人下拉框
        for (let i = 0; i < item.ZRRDM.length; i++) {
          item.zrrArr.push({ id: item.ZRRDM[i], name: item.ZRRMC[i] })
        }

        item.BCBRDM = item.BCBRDM ? item.BCBRDM.split(',') : []
        item.BCBRMC = item.BCBRMC ? item.BCBRMC.split(',') : []
        for (let i = 0; i < item.BCBRDM.length; i++) {
          item.BCHZArr.push({
            ID: item.BCBRDM[i],
            Name: item.BCBRMC[i]
          })
        }

        for (let i = 0; i < this.formData.BJCZXX.length; i++) {
          if (
            !item.BCHSDM.includes(this.formData.BJCZXX[i].split('$')[0]) &&
            this.formData.BJCZXX[i].split('$')[1] == '1'
          ) {
            item.BCHSArr.push({
              id: this.formData.BJCZDM[i],
              name: this.formData.BJCZMC[i]
            })
          }
          if (
            !item.ZRRDM.includes(this.formData.BJCZXX[i].split('$')[0]) &&
            this.formData.BJCZXX[i].split('$')[1] == '1'
          ) {
            item.zrrArr.push({
              id: this.formData.BJCZDM[i],
              name: this.formData.BJCZMC[i]
            })
          }
          if (
            !item.BCBRDM.includes(this.formData.BJCZXX[i].split('$')[0]) &&
            this.formData.BJCZXX[i].split('$')[1] == '2'
          ) {
            item.BCHZArr.push({
              ID: this.formData.BJCZDM[i],
              Name: this.formData.BJCZMC[i]
            })
          }
        }

        // 如果存在数据，有被查患者数据
        if (
          this.formData.BJCZXX.length == 0 &&
          this.formData.BJCZDM.length > 0
        ) {
          for (let n = 0; n < this.formData.BJCZDM.length; n++) {
            item.BCHZArr.push({
              ID: this.formData.BJCZDM[n],
              Name: this.formData.BJCZMC[n]
            })
          }
        }

        item.KFFS = item.KFFS ? item.KFFS : 1018
        item.BJCZDM = item.BJCZDM ? item.BJCZDM.split(',') : []
        item.BJCZMC = item.BJCZMC ? item.BJCZMC.split(',') : []
        item.DXHGL = item.DXHGL && item.DXHGL !== '0' ? item.DXHGL : ''
        item.Index = index
        item.SFWSJ = item.SFWSJ == '1'
        // 核查表默认选中第一个不扣分的项
        if (!item.KFJG && item.HCBJGList && item.HCBJGList.length > 0) {
          item.KFJG = item.HCBJGList.find((m) => m.ISNRJS == '1').JGDM
        }

        // this.$set(item, 'KFJG', item.KFJG ? String(item.KFJG) : null)
        // if (this.xtmj1179!='0') {
        //   item.firstHandle = 0
        // }
      })
    },
    // 特殊核查表计算合格率
    getHGL(list, index, row) {
      this.SET_BEFORE_CLOSE(true)
      list.YBSL = formatInput(list.YBSL.toString())
      const isnrjs = this.showField.isQualifiedRateCheck ? '0' : '1'
      //不适用数量，即为不纳入分子并且不纳入分母的数量
      let bsySl = 0
      if (this.showField.bsySfcyjs) {
        let totalYBS = eval(
          row.HCBJGList.map((item) => (item.YBSL ? item.YBSL : 0)).join('+')
        )
        bsySl = eval(
          row.HCBJGList.map((item) =>
            item.YBSL && item.ISNRFM === '0' && item.ISNRJS === '0'
              ? item.YBSL
              : 0
          ).join('+')
        )

        let totalActive = eval(
          row.HCBJGList.map((item) =>
            item.ISNRJS === isnrjs && item.ISNRFM != 0
              ? item.YBSL
                ? item.YBSL
                : 0
              : 0
          ).join('+')
        )

        let fmSl = totalYBS - bsySl
        row.HCBJGList.forEach((item) => {
          let result = 0
          if (item.ISNRFM === '0' && item.ISNRJS === '0') {
            result =
              fmSl === 0
                ? 0
                : (((item.YBSL ? item.YBSL : 0) / totalYBS) * 10000) / 10000
          } else {
            result =
              fmSl === 0
                ? 0
                : (((item.YBSL ? item.YBSL : 0) / fmSl) * 10000) / 10000
          }
          this.$set(item, 'YBZB', result.toFixed(4))
        })

        row.HGL =
          fmSl === 0 ? 0 : Math.floor((totalActive / fmSl) * 10000) / 10000
        // 合格率重新赋值
        // row.HGL = 1 - row.HGL
        // 合格率不是100%
        if (row.HGL < 1) {
          row.BCHSDM = row.BCHSArr[0] ? [`${row.BCHSArr[0].id}`] : []
          row.BCBRDM = row.BCHZArr[0] ? [`${row.BCHZArr[0].ID}`] : []
        }
      } else {
        let totalYBS = eval(
          row.HCBJGList.map((item) =>
            item.YBSL && !(item.ISNRFM === '0' && item.ISNRJS === '0')
              ? item.YBSL
              : 0
          ).join('+')
        )
        if (list.ISNRFM === '0' && list.ISNRJS === '0') {
          return
        }
        let totalActive = eval(
          row.HCBJGList.map((item) =>
            item.ISNRJS === isnrjs && item.ISNRFM != 0
              ? item.YBSL
                ? item.YBSL
                : 0
              : 0
          ).join('+')
        )
        row.HCBJGList.forEach((item) => {
          this.$set(
            item,
            'YBZB',
            totalYBS === 0
              ? 0
              : Math.floor(((item.YBSL ? item.YBSL : 0) / totalYBS) * 10000) /
                  10000
          )
        })

        row.HGL =
          totalYBS === 0
            ? 0
            : Math.floor((totalActive / totalYBS) * 10000) / 10000
        // 合格率重新赋值
        // row.HGL = 1 - row.HGL
        //分数小于一，填充被查护士和患者
        if (row.HGL < 1) {
          row.BCHSDM = row.BCHSArr[0] ? [`${row.BCHSArr[0].id}`] : []
          row.BCBRDM = row.BCHZArr[0] ? [`${row.BCHZArr[0].ID}`] : []
        }
      }
      // 1179参数开启时，自动填充扣分原因说明 抠的if里加了最后两个条件
      if (
        this.showField.xtmj1179 != '0' &&
        (row.firstHandle === 0 || !row.KFYYSM) &&
        row.KFJG !== '' &&
        row.KFJG !== '0' &&
        row.HCBJGList &&
        row.HCBJGList.some(
          (m) => m.YBSL > 0 && m.ISNRFM === '1' && m.ISNRJS === '0'
        )
      ) {
        this.dealKFYYSM(row)
      }
      // this.calcScore()
    },
    // 加扣分数据变化
    handleMark(item, index, row, type) {
      this.SET_BEFORE_CLOSE(true)
      if (row.KFJG == null) row.KFJG = 0
      row.KFJG = formatInput(row.KFJG.toString())
      // this.ifBack(row, item)
      if (
        row.JFFS === 1152 &&
        !item.startsWith('+') &&
        Number(item) != 0 &&
        Number(item) !== Number(row.KFFZ)
      ) {
        // 判断是否为完整扣分1152,当分值
        this.$msg('全部扣分只能扣除0分或者完整分!', 'info')
        row.KFFZ = row.KFFZ
        row.KFJG = Number(row.KFFZ)
      }
    },

    // 填充扣分原因说明
    dealKFYYSM(row) {
      row.firstHandle += 1 //判断是否第一次操作
      let kfmc = row.KFMC || row.BZMC
      if (this.xtmj1179 == '1') {
        row.KFYYSM = row.KFYYSM ? row.KFYYSM + '\n' + kfmc : kfmc
      } else if (this.xtmj1179 == '2' && !row.KFYYSM) {
        // 顶部被检查者有数据，遍历添加到数组里面
        var str = ''
        let strArr = []
        let hsArr = []
        let hzArr = []
        if (row.BCHSMC.length > 0) {
          row.BCHSMC.forEach((item, idx) => {
            hsArr.push(item.replace(`(${row.BCHSDM[idx]})`, ''))
          })
          if (hsArr && hsArr.length > 0) {
            strArr.push(hsArr.join(','))
          }
        }

        if (row.BCBRMC.length > 0) {
          row.BCBRMC.forEach((item, idx) => {
            hzArr.push(item)
          })
          if (hzArr && hzArr.length > 0) {
            strArr.push(hzArr.join(','))
          }
        }

        str = strArr.join(',')
        row.KFYYSM = row.KFYYSM ? row.KFYYSM + '\n' + kfmc : str + kfmc
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-window-text {
  h3 {
    margin: 0px;
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.title-container {
  display: flex;
  font-weight: 700;
  background-color: rgba(81, 117, 244, 0.5);
  height: 40px;
  line-height: 40px;
  .logo {
    width: 28px;
    height: 28px;
    margin: 4px 10px 0px 12px;
  }
  .text {
    height: 40px;
    line-height: 40px;
  }
}
/deep/ .el-dialog__headerbtn {
  top: 0px;
  height: 40px;
  right: 0px;
  font-size: 22px;
  padding: 0px 16px;
  &:hover {
    background-color: red;
  }
  .el-dialog__close {
    color: #666;
    font-weight: 700;
  }
}
/deep/ .w-table--fit {
  width: 100%;
  height: 43vh;
  overflow-y: auto;
  margin-bottom: 50px;
  border: none;
  &::before {
    height: 0px;
  }
}
/deep/ .el-dialog__header {
  padding: 0px;
}

/deep/ .w-table--border {
  &::after {
    height: 0px;
  }
}
/deep/ .w-table__body-wrapper {
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.w30 {
  width: 50%;
  margin: 0 12px;
}
.content {
  display: inline-block;
}
.radio_box {
  line-height: 22px;
}
.radio_dot {
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 15px;
  position: relative;
  top: 3px;
  margin-right: 10px;
  display: inline-block;
  cursor: pointer;
  .dot {
    width: 8px;
    height: 8px;
    position: absolute;
    top: 4px;
    right: 4px;
    border-radius: 8px;
  }
  .dot_border {
    border: 1px solid #ccc;
    background-color: #fff;
  }
  &.bg {
    border: none;
    background-color: #409eff;
  }
}
.arrow-container {
  margin-left: 10px;
  padding: 6px 8px 6px 5px;
}
.pic-people {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.w-table .cell {
  padding: 0 10px;
}
.w30 {
  width: 50%;
  margin: 0 12px;
}
.w20 {
  width: 28%;
  text-align: right;
}
.w50 {
  width: 38%;
  text-align: left;
}
</style>
